import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
    Button,
    Grid,
    TextField,
    Switch
  } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import { withStyles, makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px"
  },
});

export default function EditVehiclePopup(props: any) {
  const classes = useStyles();
  const GreenSwitch = withStyles({
    switchBase: {
      color: red[300],
      '&$checked': {
        color: green[500],
      },
      '&$checked + $track': {
        backgroundColor: green[600],
      },
    },
    checked: {},
    track: {},
    disabled: {},
  })(Switch);

  const [state, setState] = React.useState<any>(props.vehicle);

  const handleClose = () => {
    props.toggleOpen();
  };

  const handleChange = (e: any) => {
    setState({ ...state, [e.target.id]: e.target.value });
  };

  const handleSubmit = () => {
    // if (state.userType === undefined || state.userType === 'Admin') state.roleId = '0';
    // if (state.userType === undefined) state.userType = 'Individual';
    props.handleSave(state);
  };

  React.useEffect(() => {
    setState(props.vehicle);
  }, [props.vehicle]);

  return (
    <div>
      <Dialog
        open={props.isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Edit Vehicle Details"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {state?.dealership?.name} vehicle with ID {state?.id}
          </DialogContentText>
          <Grid container spacing={2} alignItems="center">
        <Grid item xs={4}>
          VIN
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            id="vin"
            margin="dense"
            onChange={handleChange}
            placeholder="vin"
            value={state.vin || ''}
            inputProps={{ maxLength: 32 }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={4}>
          Transponder
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            id="transponder"
            margin="dense"
            onChange={handleChange}
            placeholder="transponder"
            value={state.transponder || ''}
            inputProps={{ maxLength: 20 }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={4}>
          License Plate
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            id="licenseplate"
            margin="dense"
            disabled
            onChange={handleChange}
            placeholder="plate"
            value={state.licenseplate || ''}
            inputProps={{ maxLength: 20 }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={4}>
          State Code
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            id="state"
            margin="dense"
            disabled
            onChange={handleChange}
            placeholder="state"
            value={state.state || ''}
            inputProps={{ maxLength: 5 }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={4}>
          Active Status
        </Grid>
        <Grid item xs={8}>
          <div className={classes.row}>
            <GreenSwitch 
              checked={state.active_status || false} 
              size="small" 
              id="active_status" 
              name='active_status' 
              onChange={(event)=>{
                setState({ ...state, active_status: event.target.checked });
              }}
            />
          </div>
        </Grid>
      </Grid>

        </DialogContent>
        <DialogActions>
        <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
        <Button onClick={handleSubmit} color="primary" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}